import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateBillQueries } from '@/modules/common/utils/query-invalidation';

import { updateBill } from '../api';

/** Updates a bill and invalidates every list and detail snapshot. */
export const useUpdateBill = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: updateBill,
    onSuccess: () => invalidateBillQueries(queryClient),
    onError: error =>
      displayToastErrorFromApiWithFallback(error, 'authenticated.bills:toasts.updateError'),
  });
};
